import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {InboxesFiltersEnum} from '../../../../models/url/inboxesUrlModel';
import {recordUnassignedAssignedSwitchAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {getUnassignedAssignedSwitchCount} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {
  updateHasSeenTeamTabsAlertAction,
  updateShouldUseOpenFilterForTeamsAction,
} from '../../../../store/data/preferences/preferencesActions';
import {getHasSeenTeamTabsAlert} from '../../../../store/data/preferences/preferencesSelectors';
import {InboxesConversationsParameters} from '../../../../store/panels/inboxes/parameters/inboxesParameters';
import {buildParametersPath} from '../../../../store/panels/inboxes/parameters/inboxesParametersPathHelpers';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {TeamTabsDialog} from './teamTabsDialog';

/*
 * Props.
 */

interface TeamTabsDialogContainerProps {
  parameters: InboxesConversationsParameters;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<TeamTabsDialogContainerProps>()(() => ({
  hasSeenTeamTabsAlert: getHasSeenTeamTabsAlert,
  unassignedAssignedSwitchCount: getUnassignedAssignedSwitchCount,
}));

export const TeamTabsDialogContainer = connect(
  mapStateToProps,
  {
    navigateToLinkAction,
    updateHasSeenTeamTabsAlertAction,
    updateShouldUseOpenFilterForTeamsAction,
    recordUnassignedAssignedSwitch: recordUnassignedAssignedSwitchAction,
  },
  (stateProps, dispatchProps, ownProps) => {
    const {parameters} = ownProps;

    const markTeamTabsAlertAsSeen = () => {
      dispatchProps.updateHasSeenTeamTabsAlertAction(true);
    };

    const switchToTeammateTabs = () => {
      markTeamTabsAlertAsSeen();
      dispatchProps.updateShouldUseOpenFilterForTeamsAction(true);

      const newParameters: InboxesConversationsParameters = {
        ...parameters,
        filters: [InboxesFiltersEnum.OPEN],
      };

      dispatchProps.navigateToLinkAction(buildParametersPath(newParameters));
    };

    return {
      ...stateProps,
      ...ownProps,
      recordUnassignedAssignedSwitch: dispatchProps.recordUnassignedAssignedSwitch,
      switchToTeammateTabs,
      markTeamTabsAlertAsSeen,
    };
  },
)(TeamTabsDialog);
